// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_1lFRx","wrapperMode":"style_wrapperMode_3uKHJ","wrapperOpacity":"style_wrapperOpacity_fmbpu"};